import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ApiVisa } from 'blg-akaun-ts-lib';
import { PermissionStates } from '../../modules/permission/permission-controller/root';
import { UserPermInquirySelectors } from '../../modules/permission/user-permissions-inquiry-controller/selectors';
import { SessionActions } from '../../modules/session/session-controller/actions';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';
import { DropDownService } from '../../services/drop-down-service';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-select-multi-customer-category-drop-down',
  templateUrl: './select-multi-customer-category-drop-down.component.html',
  styleUrls: ['./select-multi-customer-category-drop-down.component.css']
})
export class SelectMultiCustomerCategoryDropDownComponent implements OnInit, OnDestroy {

  @Input() customerCategories: FormControl;
  @Input() apiVisa: ApiVisa;
  @Input() selectedGuid: string;
  @Input() label = 'Customer Category(s)';
  @Input() options: any;
  @Input() readPermissionDefintion;

  @Output() customerCategorySelected = new EventEmitter<any>();

  userPermissionTarget$ = this.permissionStore.select(
    UserPermInquirySelectors.selectUserPermInquiry
  );

  serverSideFiltering = new FormControl();
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  selectedRow: any;
  rowData: any = [];
  key = 'customer-category/backoffice-ep';
  allSelected = false;
  filteredCache: any = [];
  customerCategoryTargets: string[]=[];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  protected _onDestroy = new Subject<void>();
  private subs = new SubSink();

  constructor(private dropDownService: DropDownService, 
    private readonly store: Store<SessionStates>,
    private readonly permissionStore: Store<PermissionStates>
  ) { }

  ngOnInit() {
    // set initial selection
    this.store.select(SessionSelectors.selectDropDownRowData).subscribe(resolved => {
      this.rowData = resolved?resolved[this.key]?resolved[this.key]:[]:[];
      if (this.rowData.length === 0) {
        this.getRowData();
      }
      else {
        this.filteredOptions$.next(this.rowData.slice());
      }
    })

    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtering();
      });
    
      this.userPermissionTarget$.subscribe((targets) => {
        let target = targets.filter(
          (target) => target.permDfn === this.readPermissionDefintion
        );

        this.customerCategoryTargets =
        target[0]?.target !== null &&
        Object.keys(target[0]?.target || {}).length !== 0
          ? target[0]?.target["bl_fi_mst_entity_label_hdr"]
          : [];
      });

      console.log("readPermissionDefintion", this.readPermissionDefintion);
  }


  ngOnChanges() {
    //console.log('ngOnChanges');
  }

  getRowData() {
    let formData = {
      "limit" : null,
      "orderBy" : "code",
      "order" : "ASC"
    }

    this.dropDownService.get(this.key, formData, this.apiVisa).subscribe(resolved => {
      this.rowData = resolved.data;
      if(this.customerCategoryTargets?.length>0){
        this.rowData = this.rowData.filter(record=>this.customerCategoryTargets.includes(record.guid))
      }
      this.store.dispatch(SessionActions.selectDropDownRowData({key: this.key, rowData: this.rowData}));
      //fill the drop down
      this.filteredOptions$.next(this.rowData.slice());
    });
  }

  filtering() {
    if (!this.rowData) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.rowData.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter 
    this.filteredOptions$.next(
      this.rowData.filter((option) =>
        (option.code ?
          option.code.toLowerCase().indexOf(search) > -1 : null) ||
        (option.name ?
          option.name.toLowerCase().indexOf(search) > -1 : null))
    );
  }

  onSelect(guid: string) {
    if (guid) {
      this.customerCategories.patchValue(guid);
      this.selectedRow = this.rowData.find(row => row.guid === guid);
      this.customerCategorySelected.emit(this.selectedRow);
    }
  }

  isRequired() {
    let value = this.options['required'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false; 
  }

  isMultiple() {
    let value = this.options['multiple'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false; 
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredOptions$.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          this.customerCategories.patchValue([...val.map(item => item.guid)]);
        } else {
          this.customerCategories.patchValue([]);
        }
      });
  }

  setToggleAllCheckboxState() {
    if (!this.isMultiple()) return;
    let filteredLength = 0;
    if (this.customerCategories && this.customerCategories.value) {
      this.filteredCache.forEach(el => {
        if (this.customerCategories.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate = filteredLength > 0 && filteredLength < this.filteredCache.length;
      this.isChecked = filteredLength > 0 && filteredLength === this.filteredCache.length;
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
